// extracted by mini-css-extract-plugin
export var blue = "_27-g";
export var brand = "_27-c";
export var darkGrey = "_27-f";
export var disabled = "_27-6";
export var disabledSubtle = "_27-7";
export var error = "_27-8";
export var green = "_27-h";
export var grey = "_27-e";
export var icon = "_27-0";
export var inherit = "_27-b";
export var lightGrey = "_27-d";
export var orange = "_27-j";
export var pink = "_27-l";
export var primary = "_27-1";
export var purple = "_27-m";
export var quaternary = "_27-4";
export var quinary = "_27-5";
export var red = "_27-k";
export var secondary = "_27-2";
export var success = "_27-a";
export var tertiary = "_27-3";
export var warning = "_27-9";
export var white = "_27-n";
export var yellow = "_27-i";